import React from 'react';
import Button from '@material-ui/core/Button';
import MenuItemAnchor from './MenuItemAnchor';

function isVisible(user) {
    return !user.isAuthenticated;
}

function Toolbar(props) {
    const {user, nextFromRegister, ...restProps} = props;

    if (!isVisible(user)) return null;

    return (<Button
        {...restProps}
        style={{...props.style, color: '#fff'}}
        variant="contained"
        color="primary"
        href={`/register/${nextFromRegister}`}
    >{gettext('Sign Up')}</Button>);
}

function HamburgerMenu(props) {
    const {user, nextFromRegister, ...restProps} = props;

    if (!isVisible(user)) return null;

    return (<MenuItemAnchor {...restProps} href={`/register/${nextFromRegister}`}>
        {gettext('Sign Up')}
    </MenuItemAnchor>);
}

export default { Toolbar, HamburgerMenu };
